export default __webpack_public_path__ + "static/media/ativo-16.a15e0e4e.svg";